import type { ValueInsightStats } from "@functions/services/valueInsights/valueInsightsTypes";

export async function getValueInsights(
    workspaceId: string,
    { filterEmptyAnnotations = false }: { filterEmptyAnnotations?: boolean } = {}
): Promise<ValueInsightStats> {
    const params = new URLSearchParams();
    if (filterEmptyAnnotations) {
        // Sometimes annotation objects or arrays are empty. This parameter prevents those from being returned.
        params.set("filterEmptyAnnotations", "true");
    }
    const response = await fetch(`/query/${workspaceId}/valueInsights?${params}`);

    if (!response.ok) {
        const body = await response.text().catch(() => "");
        throw new Error(
            `ValueInsightsApiError: ${response.status} ${response.statusText}${body ? ` - ${body}` : ""}`
        );
    }

    return response.json();
}
